import script from "./FileUploadPop.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUploadPop.vue?vue&type=script&setup=true&lang=ts"

import "./FileUploadPop.vue?vue&type=style&index=0&id=3802e51f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3802e51f"]])

export default __exports__